import _axios from '@/utils/request'

// 医生分页列表
export function postDoctorApplyList(params) {
    return _axios('post', `/ms-shulan-hospital/v1/doctorApply/pageDoctorApply`, params)
}

// 通过认证incId取认证单详情
export function getApplyIdByIncId(incId) {
    return _axios('get', `/ms-shulan-hospital/v1/doctorApply/byApplyId/${incId}`)
}

export function putDoctorApply(params) {
    return _axios('put', '/ms-shulan-hospital/v1/doctorApply', params)
}
